const getLocalStorageValue = (key) => JSON.parse(window.localStorage.getItem(key));

export default getLocalStorageValue;
